import { Config } from '.';

const config: Config = {
    API_URL: 'https://api.api-management-tool.co.uk',
};

export default config;
